export class TypeNovelty {
    static ING = 'ING'
    static RET = 'RET'
    static SLN = 'SLN'
    static VACLR = 'VAC-LR'
}